import { ReactElement } from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../../theme'

interface FilterAppliedCountChipProps {
  count: number
}

export const FilterAppliedCountChip = ({
  count,
}: FilterAppliedCountChipProps): ReactElement | null => {
  if (count < 1) {
    return null
  }

  return <Chip aria-hidden>{count}</Chip>
}

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 9999px;
  background: #fdebad;
  border: 1px solid #f9c1001a;
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  color: ${defaultTheme.colors.black};
`
